export default {
  data() {
    return {
    };
  },
  methods: {
    calculateFontSize(baseValue, dynamicValue) {
      return `${baseValue - (dynamicValue * this.data.length)}vw`;
    },
  },
  computed: {
    titleFontSize() {
      return this.calculateFontSize(1.2, 0.1);
    },
    valueFontSize() {
      return this.calculateFontSize(1.6, 0.1);
    },
  },
  props: ['data'],
  template: '<div class="top-data">' +
    '<router-link v-for="(item, index) in data" v-bind:key="index" v-bind:to="item.link">' +
    '<div class="column" v-bind:style="{ width: 100 / data.length + \'%\' }">' +
    '<div class="top-data-item">' +
    '<div class="top-data-icon"><i class="fal" v-bind:class="item.icon"></i></div>' +
    '<div class="top-data-title" v-bind:style="{ fontSize: titleFontSize }">{{ item.title }}</div>' +
    '<div class="top-data-value" v-bind:style="{ fontSize: valueFontSize }">{{ item.value }}</div>' +
    '</div>' +
    '</div>' +
    '</router-link></div>',
};



// WEBPACK FOOTER //
// ./src/components/TopData.js